import { useBreakpoints } from '../../../bookings/util/useBreakpoints';
import { LinkTrackingData } from '../../../common/AnalyticsContext/LinkTracking';
import {
  AppointmentsView,
  CtaLink,
} from '../../ResultView/ResultList/ProfileCards/search-card/Appointments/Appointments.styles';
import { CtaLinkWithTapTarget } from '../../ResultView/ResultList/ProfileCards/search-card/Appointments/CtaLinkWithExperiment';
import { Meat } from '../../ResultView/ResultList/ProfileCards/search-card/Appointments/NextAvailable/NextAvailable.styles';
import { Label, NextAvailableView } from './SearchAction.styles';

export interface Props {
  clickTracking: LinkTrackingData;
  label?: string;
  ctaText?: string;
  nextUrl?: string;
}

export const SearchAction = ({
  clickTracking,
  label,
  nextUrl,
  ctaText = 'Find out more',
}: Props) => {
  const breakpoints = useBreakpoints();

  return (
    <AppointmentsView>
      <NextAvailableView>{label && <Label>{label}</Label>}</NextAvailableView>
      {ctaText &&
        nextUrl &&
        (breakpoints.Small ? (
          <CtaLinkWithTapTarget trackingData={clickTracking} to={nextUrl}>
            Find out more
          </CtaLinkWithTapTarget>
        ) : (
          <Meat>
            <CtaLink trackingData={clickTracking} to={nextUrl}>
              Find out more
            </CtaLink>
          </Meat>
        ))}
    </AppointmentsView>
  );
};
